var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.exportXlsx.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$lang('Eksport XLSX'))+"\n    ")]),_vm._v(" "),_c('loading-widget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }